// start:ng42.barrel
export * from './diagnosis.facade';
export * from './diagnosis.model';
// end:ng42.barrel

